export default {
  company: {
    company_informations: '会社設定',
    name: '名称',
    main_event: 'メインイベント',
    color: '色',
    logo: 'ロゴ',
    right_header_logo: 'ヘッダー右側のロゴ',
    title_of_the_plateform: 'プラットフォームのタイトル',
    address: '住所',
    contact: '連絡先',
    phone: '電話番号',
    save: '保存',
    salesforce_credentials: 'Salesforce認証情報',
    client_id: 'クライアントID',
    client_secret: 'クライアントシークレット',
  },
};
